// Copyright (c) StrangeBee 2024

import { FREETAGS_NAMESPACE } from '@Constants/case';
import { TagOutput } from 'thehive-sdk';

export const formatTags = (tag: Partial<TagOutput>): string => {
    const { namespace = '', predicate = '', value = '' } = tag || {};

    const namespaceFormatted = namespace !== FREETAGS_NAMESPACE ? `${namespace}:` : '';
    const formattedValue = value ? `="${value}"` : '';

    return `${namespaceFormatted}${predicate}${formattedValue}`;
};

export const trimTags = (tags: string[]): string[] =>
    tags.reduce((acc, value) => {
        const valueTrimmed = value.trim();

        return valueTrimmed ? [...acc, valueTrimmed] : acc;
    }, [] as string[]);
